import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  Switch,
  Route,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import { useMst } from "@store/Route";
import { checkExtToken } from "@utils/validation";
import DashboardPayments from "@view/payments/Payments";
import Manage from "@view/manage/Manage";
import Schedule from "@view/schedule/Schedule";
import SummaryStripe from "@view/payments/SummaryStripe";

// Dashboard Route
const DashboardRoute = withRouter(
  observer((props: RouteComponentProps) => {
    const { landing, profile } = useMst();
    const { token, exp, setInitial, deleteToken } = landing;

    useEffect(() => {
      console.log(token);
      if (!token || !exp || checkExtToken(exp)) {
        props.history.push("/");
        setInitial();
        deleteToken();
      }
      if(token){
          profile.getProfile(token)
      }
    }, [token]);

    return (
      <Switch>
        <Route
          path="/dashboard/schedule"
          component={Schedule}
          key="SchedulePayments"
        />

        <Route path="/dashboard/payment/stripe/:url">
          <SummaryStripe></SummaryStripe>
        </Route>

        <Route
          path="/dashboard/payment/stripe"
          component={SummaryStripe}
          key="SummaryStripe"
        />

        <Route
          path="/dashboard/payment"
          component={DashboardPayments}
          key="DashboardPayments"
        />

        <Route path="/dashboard/manage" component={Manage} key="Manage" />

        <Redirect from="/dashboard" to="/dashboard/schedule" />
      </Switch>
    );
  })
);

export default DashboardRoute;
